import React from "react";

const ContactSection = () => {
  return (
    <>
      <div className="contact-main breadcrumb-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-12">
              <div className="breadcrumb-content">
                <h3>Let's Contact</h3>
                <p>
                  Hendrerit porttitor ornare platea ante amet arcu at nunc.
                  Suscipit feugiat sagittis, id duis faucibus sit ultrices.
                  Netus sem diam turpis sollicitudin blandit massa ornare
                  facilisi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="contact-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="contact-inner">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-12">
                    <form action="#" method="post">
                      <div className="contact-form">
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                Full name <span className="error">*</span>
                              </label>
                              <input
                                type="text"
                                name="Name"
                                placeholder="ex: +088123456789"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                Email Address <span className="error">*</span>
                              </label>
                              <input
                                type="email"
                                name="Email"
                                placeholder="ex: yourmail@mail.com"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                Subject <span className="error">*</span>
                              </label>
                              <input
                                type="text"
                                name="Subject"
                                placeholder="Subject here"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                Message <span className="error">*</span>
                              </label>
                              <textarea
                                name="message"
                                placeholder="Any message"
                                required="required"
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="contact-btn">
                              <button
                                type="submit"
                                className="theme-btn primary"
                              >
                                Send
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="contact-details">
                      <h3 className="c-details-title">Contact Information</h3>
                      <ul>
                        <li>
                          <a href="mailto:sales@softifybd.com">
                            <i className="fa fa-envelope"></i>
                            sales@softifybd.com
                          </a>
                        </li>
                        <li>
                          <a href="tel:+8801842117900">
                            <i className="fa fa-whatsapp"></i>+8801842117900
                          </a>
                        </li>
                        <li>
                          <a href="tel:+8801842117906">
                            <i className="fa fa-whatsapp"></i>+8801842117906
                          </a>
                        </li>
                        <li>
                          <a href="tel:+8801842117903">
                            <i className="fa fa-whatsapp"></i>+8801842117903
                          </a>
                        </li>
                        <li>
                          <a href="tel:+8801730797262">
                            <i className="fa fa-whatsapp"></i>+8801730797262
                          </a>
                        </li>
                        <li>
                          <a href="tel:+8809613228899">
                            <i className="fa fa-phone"></i>+8809613228899
                          </a>
                        </li>
                      </ul>
                      <div className="maps-area">
                        <div className="main-maps">
                          <iframe
                            width="434"
                            height="500"
                            id="gmap_canvas"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.697730945293!2d90.50685131438574!3d23.615171099846922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b165a1921a09%3A0xb58f02520cb0cb41!2sSoftifyBD%20Ltd.!5e0!3m2!1sen!2sbd!4v1625404711459!5m2!1sen!2sbd"
                            frameBorder="0"
                            scrolling="no"
                            marginHeight="0"
                            marginWidth="0"
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;
